import { Button, Stack, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { FooterAttachmentData } from '../types'
import { asText } from '@prismicio/client'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const FooterAttachmentSection: FC<{ data?: FooterAttachmentData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  if (!data) return null
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={theme.spacing(10)}
      sx={{
        width: '100%',
        backgroundColor: theme.palette.primary.dark,
        padding: { xs: '48px 28px 20px 28px', md: '52px' }
      }}
      id={sectionId}
    >
      <PrismicText
        richTextField={data.primary?.header}
        variant="display/large"
        fontSize={{ xs: '24px', md: '28px', lg: '32px' }}
        color="primary.white"
        textAlign="center"
        lineHeight={{ xs: '30px', md: '40px' }}
      />
      {asText(data.primary?.subheader) && (
        <Stack
          direction="column"
          sx={{
            maxWidth: '604px',
            marginTop: theme.spacing(4)
          }}
          justifyContent="center"
        >
          <PrismicText
            richTextField={data.primary?.subheader}
            variant="body/large"
            fontSize={{ xs: '14px', md: '16px', lg: '20px' }}
            color="primary.white"
            textAlign="center"
            lineHeight="24.5px"
          />
        </Stack>
      )}
      <Stack direction="row" alignItems="center">
        <Button
          data-heap-id="FooterAttachmentSection_CTAButton"
          href={data.primary?.button_href?.url}
          variant="contained"
          color="tertiary"
        >
          {data.primary?.button_label}
        </Button>
      </Stack>
    </Stack>
  )
}

export default FooterAttachmentSection
